export default {
  filename:  '',
  part_number: '',
  revision: '',
  quantities: ['10', '25', '50', '100'],
  number_of_layers: '2',
  board_length: '',
  board_width: '',
  silkscreen_sides: '',
};
